import { jsx, jsxs } from "react/jsx-runtime";
import { styled, Icon } from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
const Container = styled("div")(({ theme }) => ({
  ".arrow-text": {
    fontSize: 14,
    fontWeight: 600,
    display: "flex",
    gap: 8,
    alignItems: "center",
    color: theme.vars.palette.text.primary,
    margin: `5px 0`,
    ":hover": {
      cursor: "pointer"
    }
  }
}));
const IconComponent = /* @__PURE__ */ jsx(Icon, { sx: (theme) => ({ color: theme.vars.palette.primary.main }), children: /* @__PURE__ */ jsx(ArrowRightAltIcon, {}) });
const ArrowLink = ({ text, url, Link, onTextClick }) => {
  const handleClick = () => {
    if (onTextClick) onTextClick();
  };
  return /* @__PURE__ */ jsx(Container, { children: Link && url ? /* @__PURE__ */ jsxs(Link, { to: url, style: { textDecoration: "none" }, className: "arrow-text", children: [
    text,
    IconComponent
  ] }) : /* @__PURE__ */ jsxs("div", { onClick: handleClick, className: "arrow-text", children: [
    text,
    IconComponent
  ] }) });
};
export {
  ArrowLink
};
//# sourceMappingURL=ArrowLink.js.map
